import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface SnackbarAction {
    label: string;
    handler: () => void;
}

interface SnackbarData {
    message: string;
    actions?: SnackbarAction[];
}

@Injectable({ providedIn: 'root' })
export class SnackbarService {
    public snackbarSubject = new Subject<SnackbarData>();
    public snackbarState$ = this.snackbarSubject.asObservable();

    public showSnackbar(message: string, actions: SnackbarAction[] = []) {
        this.snackbarSubject.next({ message, actions });
    }
}